export const state = {
  ageGateToken: sessionStorage.getItem('ageGateToken')?true:false, 
  loggedIn: false,
  activeSection: 'hero',
  triggerSpring: 0,
  scrollMotion: 'upStart',
  edgeScrolling: 0,
}